import { api } from "../api";

export interface ProfileResponse {
  individual_context: Record<string, unknown>;
  organizational_context: Record<string, unknown>;
}

export interface ProfileUpdateRequest {
  individual_context?: Record<string, unknown>;
  organizational_context?: Record<string, unknown>;
}

export const fetchProfile = async (): Promise<ProfileResponse> => {
  return api.get("api/profile").json<ProfileResponse>();
};

export const updateProfile = async (
  data: ProfileUpdateRequest
): Promise<ProfileResponse> => {
  return api.put("api/profile", { json: data }).json<ProfileResponse>();
};

